import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

declare const window: any;

export interface AppConfig {
    env: any;
}

@Injectable({
    providedIn: "root",
})
export class AppConfigService {
    private config: any;
    loaded = false;

    constructor(private http: HttpClient) { }
    public loadConfig(): Promise<void> {
        return this.http
            .get<AppConfig>('/assets/app-config.json')
            // .get<AppConfig>('/sae-student-ui/src/assets/app-config.json')
            .toPromise()
            .then(data => {
                this.config = data;
                this.loaded = true;
            });
    }

    public getConfig() {
        return this.config;
    }
}